// extracted by mini-css-extract-plugin
module.exports = {"secondSider":"second-sider_secondSider__1ouoQ","menuItem":"second-sider_menuItem__3Nj8l","title":"second-sider_title__J3-o_"};